import { render, staticRenderFns } from "./IntegrationBase.vue?vue&type=template&id=7d2a886e&scoped=true&"
import script from "./IntegrationBase.vue?vue&type=script&lang=ts&"
export * from "./IntegrationBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2a886e",
  null
  
)

export default component.exports